import { Box, Typography } from "@mui/material";
import { FC, ReactNode, SyntheticEvent } from "react";
import { EIconNames } from "src/shared/types/iconNames";
import { IconButton } from "../index";

export interface IModalHeaderProps {
  title?: ReactNode;
  onCrossClick: () => void;
  hasShadow?: boolean;
}

const ModalHeader: FC<IModalHeaderProps> = ({
  title,
  hasShadow,
  onCrossClick,
}) => {
  return (
    <Box
      sx={{
        pl: 6,
        py: 5,
        pr: 5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: hasShadow ? "0px 10px 20px rgba(35, 33, 42, 0.05)" : "none",
      }}
    >
      {!!title && (
        <Typography
          component="h5"
          sx={{
            fontSize: "1.25rem",
          }}
        >
          {title}
        </Typography>
      )}
      <IconButton
        sx={{ marginLeft: "auto", marginRight: -2.5 }}
        color="secondary"
        iconName={EIconNames.CROSS}
        onClick={(e: SyntheticEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          onCrossClick();
        }}
      />
    </Box>
  );
};

export default ModalHeader;
